export default {
	"generic": {
		'loading': "Loading",
		'previous': "Previous",
		'next': "Next",
		'calender': "Calender",
		'today': "Today",
		'week': "Week",
		'add_event': "Add Event",
		'select_language': "Select language",
	},
}


// WEBPACK FOOTER //
// ./src/locale/en.js